import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { success, triggleLogin } from '@api/home/store/slice/loginSlice';
import { routesPath } from '@api/home/utils';
import { useSearch } from '@hooks';
import { isMobileProject, setSearchParams } from '@utils/index';
import { Processor } from '@utils/tool';

import { addReview, checkReview, getProductReviews, ReviewsQuery, setReviewLike } from '../action';
import { ctx } from '../utils';

import type { OusideProps } from '../types'

type Props = { page?; pageSize?; pageSizeNum? }

const useWidget = (props: OusideProps & Props) => {
  const { id, skuId, title, onAddCart, cartButtonId, addCartSlot } = props
  const { page = 1, pageSize = 10, pageSizeNum = 10 } = props
  const [state, setState] = ctx.useState()

  const { isLoading, mutation } = useSearch(
    (params = queryRef.current) =>
      getProductReviews(params).then((res) => {
        setState(res)
      }),
    [id]
  )

  const dispatch = useDispatch()

  const isLogin = useSelector((state: any) => state.app.isLogin)

  const queryRef = useRef<ReviewsQuery>({
    productsId: id,
    page,
    pageSize
  })

  const queryReviewPhotos = async () => {
    const res = await getProductReviews({
      star: 0,
      order: 1,
      page: 1,
      pageSize: 300,
      productsId: id,
      isWithImages: 0
    }).catch((err) => {
      //queryReviewPhotos()
      throw new Error(err.message)
    })

    //console.log('res.reviews', JSON.stringify(res.reviews))
    setState({
      reviewPhotos: res.reviews.map((data) => data.medium)?.flat(1),
      reviewCard: res.reviews
    })
  }

  const saveQueryCondition = (data: ReviewsQuery) => {
    return Object.assign(queryRef.current, data)
  }

  const restPaginationCondition = () => {
    return Object.assign(queryRef.current, { page, pageSize })
  }

  //根据登录状态谈起登录框
  const checkLogin = (callback?: Function) => {
    if (isLogin) {
      return callback()
    } else {
      if (isMobileProject) {
        window.location.href =
          routesPath.login +
          setSearchParams({
            backUrl: window.location.pathname + '#reviews',
            hide: 'true'
          })
        return
      }

      //const promise = Processor.toPromise()
      dispatch(triggleLogin(true))
      dispatch(success(() => callback()))
      return Promise.reject()
    }
  }

  const onWrite = async () => {
    //1.检查是否可以评论
    const data = await checkReview(id, skuId)
    setState(data)
    //2.唤起评论窗口
    setState({ open: true })
    // checkLogin(async () => {})
  }

  //提交评论按钮响应
  const onAddReview = async (data) => {
    await addReview({ productsId: id, skuId, ...data })
    await mutation()
    // setState({  open: false })
    return
  }

  const onLike = (data) => {
    data.productsId = id
    return checkLogin(() => setReviewLike(data))
  }

  const onDisLike = (data) => {}

  const onShare = () => {}

  const onReply = () => {}

  const onOrderFilter = (num: 1 | 2 = 1) => {
    restPaginationCondition()
    mutation(saveQueryCondition({ order: num }))
  }

  const onAllReviews = () => {
    restPaginationCondition()
    mutation(saveQueryCondition({ order: 1, star: 0, isWithImages: 0 }))
  }

  const onRatingFilter = (num: number) => {
    restPaginationCondition()
    setState({ selectValue: num })
    mutation(saveQueryCondition({ star: num, isWithImages: 0 }))
  }

  const onMediaFilter = (num: 0 | 1) => {
    restPaginationCondition()
    mutation(saveQueryCondition({ star: 0, isWithImages: num }))
  }

  const onPaginationChange = (page: number, pageSize: number) => {
    console.log(page, pageSize)
    mutation(saveQueryCondition({ page, pageSize }))
  }

  useEffect(() => {
    if (window.location.hash.indexOf('#reviews') > -1) {
      setTimeout(() => {
        document.getElementById('reviews')?.scrollIntoView({
          //top:'',
          //block: 'end',
          inline: 'nearest',
          behavior: 'smooth'
        })
        setState({ isExpand: true })
        console.log('smooth')
      }, 1000)
    }

    queryReviewPhotos()
  }, [])

  // useEffect(() => {
  //   if (Number(state.reviewNum) == 0) {
  //     setState({ isExpand: true })
  //   }
  // }, [state.reviewNum])

  const returns = {
    id,
    pageSizeNum,
    page,
    pageSize,
    cartButtonId,
    addCartSlot,
    onOrderFilter,
    queryReviewPhotos,
    isLoading,
    title,
    onAddCart,
    onWrite,
    onLike,
    onDisLike,
    onShare,
    onReply,
    onRatingFilter,
    onMediaFilter,
    onPaginationChange,
    onAddReview,
    onAllReviews
  }

  ctx.useHandle('current', returns)
  ctx.useHandle('reviewsQuery', queryRef.current)
  return returns
}

export type RefWidget = ReturnType<typeof useWidget>

export default useWidget
